import React, {Component,Fragment} from 'react';
import moment from 'moment';
//import {get,postWithHeadersResponse,putWithHeadersResponse} from '../../../server/actions'
import {MONTH} from "../../../../server/constants";
import './menuCal.css';
import NotificationSystem from 'react-notification-system';
import {_addNotificationError, _addNotification} from "../../../../server/util";
import {BeatLoader} from 'react-spinners'
import { Draggable, Droppable } from 'react-drag-and-drop'
const MealTypes={
    breakfast:'BREAKFAST',
    meal:'MEAL',
    side:'SIDE',
    holiday:'HOLIDAY'
};
let rowid=0;
const modalStyles = {
  content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: '30%',
      transform: 'translate(-50%, -50%)',
      overflow: 'initial'
  }
};
export default class MenuCal extends Component {
  constructor(props){
    super(props);
    this.state = {
        loading: false,
        orderedMenu: [],
        date: this.props.selectedDate|| moment(),
        showCalendar: true,
        pdfLink: '',
        selectedDate:moment(),
        menuItemModalIsOpen:false,
        menuItemModalDelIsOpen:false,
        showReasonModal:false,
        selectedMIdForDel:{
            date:'',id:0,reason:''
        },
        menuItem:{
            id:'0', title:'',desc:'',price:'',reducedPrice:'',start:'',type:''
        },
        breakFastItem:{
            "itemId":0, "itemName":"", "desc":"", "price":0, "breakfastDate":"", "operationCode":0
        }
  }
  this._notificationSystem = null;
  this.buildCalender=this.buildCalender.bind(this);
  this.onDrop=this.onDrop.bind(this);
  }
  componentWillReceiveProps=(nextProps)=>{
    this.setState({date:nextProps.selectedDate});
  }  
  componentWillMount = () => {
  }
  onDrop=(data,e)=>{
    let newDate=e.currentTarget.parentElement.getAttribute('data-date');
    let _idx=this.props.events.findIndex(ev=>{
      return ev.id==data.menu && ev.date===newDate
    })
    if(_idx===-1){
      let _item=this.props.itemList.find((item)=>{
        return item._links.self.href.split('/').pop()==data.menu
      })
      if(_item){
        this.props.onEventDrag({
          title:_item.mealName,
          id:data.menu,
          date:newDate,
        })
      }
    }
  }
  buildCalender=(month,year)=>{
    let firstDay = moment([ parseInt(year), parseInt(month)-1]).day();
    let daysInMonth = parseInt(moment([ parseInt(year), parseInt(month)-1]).endOf('month').format('DD'));
    let date=1;
    console.log(this.state.orderedMenu);
   return (
      <table className="table table-bordered table-responsive" id="calendar">
            <thead >
            <tr className="bg-color-1 tblHead">
                 <th className="col-lg-2" style={{display:'none'}}>Sun</th> 
                <th className="col-lg-2">Mon</th>
                <th className="col-lg-2">Tue</th>
                <th className="col-lg-2">Wed</th>
                <th className="col-lg-2">Thu</th>
                <th className="col-lg-2">Fri</th>
                <th className="col-lg-2" style={{display:'none'}}>Sat</th> 
            </tr>
            </thead>
            <tbody>
              {
                [0,1,2,3,4,5].map((i)=>{
                 return(  <tr>{
                  [0,1,2,3,4,5, 6].map((j)=>{                                       
                    if(i===0 && j<firstDay){
                      return (j===0 || j===6)?<td style={{display:'none'}}></td>: <td className="tblBodyCol">{}</td>
                    }else if(date > daysInMonth){
                      return (j===0 || j===6)?<td style={{display:'none'}}></td>: <td className="tblBodyCol">{}</td> 
                                       
                    }else{
                      let _todayMealList=[];
                      _todayMealList=  this.state.orderedMenu.filter(item=>{
                       return moment(item.start).format('YYYY-MM-DD')===moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD');
                      })
                      let _str=(j===0 || j===6)?<td style={{display:'none'}}></td>:
                      <td className="tblBodyCol" data-date={moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD')}>
                        <div className="tblBodyColDate">{date}</div>
                        <Droppable
                            enabled 
                            types={['menu']} // <= allowed drop types
                            data-date={moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD')}
                            onDrop={(data,e)=>
                            {
                              this.onDrop(data,e);
                            }}>
                            <div style={{minHeight : '120px'}}>
                              <ul>
                                {this.props.events.map((ev)=>{
                                  if(moment(ev.date,'YYYY-MM-DD').format('YYYY-MM-DD')===moment(new Date(parseInt(year),(parseInt(month)-1),date)).format('YYYY-MM-DD')){
                                    return (<li>
                                      <Draggable type="menu" data={ev.id}>
                                        <div className="label-primary eventItem">
                                          <span>{ev.title}</span>
                                            <span className="pull-right">
                                              <a href="JavaScript:void(0);" data-id={ev.id} data-date={moment(ev.date,'YYYY-MM-DD').format('YYYY-MM-DD')}
                                              className="btn-facebook-link color-3" 
                                              style={{fontSize:'13px'}} 
                                              onClick={(e)=>{
                                                let mealId=e.currentTarget.getAttribute('data-id');
                                                let _mealDate=e.currentTarget.getAttribute('data-date');
                                                this.props.deleteMenuItem(mealId,_mealDate);
                                              }}>
                                                <i className="fa fa-trash"></i>
                                              </a>
                                          </span>
                                        </div>
                                      </Draggable>
                                    </li>)
                                  }
                                })}
                              </ul>
                            </div>
                        </Droppable>
                      </td>
                      date++;
                      return _str;
                    }
                  })}
                  </tr>);
                })
              }
            </tbody>
     </table>
   )
  }
  render() {
    if (!this.state.showCalendar) {
        return (
            <div>
                <h4>Loading ...</h4>
            </div>
        )
    }
    else {
        return (
            <Fragment>   
                <div className="row margin-top-10 mr-bt-5 manage-order-pdf-row">                
                <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12"><h4
                        className="text-center color-3">{this.state.date.format('MMMM') + ' ' + this.state.date.format('YYYY')}</h4>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="pull-right">
                    </div>
                    </div>
                    </div>
                <div className="table-responsive mr-bt-10">
                {this.buildCalender(moment(this.state.date).format('MM'),moment(this.state.date).format('YYYY'))}
                </div>
            </Fragment>)
    }
}
}

  
  


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/NewMenu/menuCal.jsx